/* Cottonwool Creations — Theme JS
   MOCO Software © 2026 */
"use strict";

/* ---- Mobile Navigation ---- */
(function () {
  const toggle = document.querySelector(".cw-nav-toggle");
  const drawer = document.getElementById("cw-drawer");
  const overlay = document.getElementById("cw-overlay");
  const iconMenu = toggle && toggle.querySelector(".cw-icon-menu");
  const iconClose = toggle && toggle.querySelector(".cw-icon-close");

  if (!toggle || !drawer || !overlay) return;

  function openDrawer() {
    drawer.classList.add("open");
    overlay.classList.add("open");
    toggle.setAttribute("aria-expanded", "true");
    drawer.removeAttribute("aria-hidden");
    if (iconMenu) iconMenu.hidden = true;
    if (iconClose) iconClose.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    drawer.classList.remove("open");
    overlay.classList.remove("open");
    toggle.setAttribute("aria-expanded", "false");
    drawer.setAttribute("aria-hidden", "true");
    if (iconMenu) iconMenu.hidden = false;
    if (iconClose) iconClose.hidden = true;
    document.body.style.overflow = "";
  }

  toggle.addEventListener("click", function () {
    drawer.classList.contains("open") ? closeDrawer() : openDrawer();
  });

  overlay.addEventListener("click", closeDrawer);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("open")) closeDrawer();
  });

  // Close on any drawer link click
  drawer.querySelectorAll("a").forEach(function (link) {
    link.addEventListener("click", closeDrawer);
  });
})();

/* ---- Carousel ---- */
document.querySelectorAll(".cw-carousel").forEach(function (carousel) {
  var track = carousel.querySelector(".cw-carousel-track");
  var slides = carousel.querySelectorAll(".cw-carousel-slide");
  var dots = carousel.querySelectorAll(".cw-carousel-dot");
  var prevBtn = carousel.querySelector(".cw-carousel-btn-prev");
  var nextBtn = carousel.querySelector(".cw-carousel-btn-next");

  if (!track || slides.length === 0) return;

  var current = 0;
  var timer;

  function goTo(index) {
    current = (index + slides.length) % slides.length;
    track.style.transform = "translateX(-" + current * 100 + "%)";
    dots.forEach(function (d, i) {
      d.classList.toggle("active", i === current);
    });
  }

  function next() {
    goTo(current + 1);
  }
  function prev() {
    goTo(current - 1);
  }

  function startAuto() {
    timer = setInterval(next, 5000);
  }
  function resetAuto() {
    clearInterval(timer);
    startAuto();
  }

  if (nextBtn)
    nextBtn.addEventListener("click", function () {
      next();
      resetAuto();
    });
  if (prevBtn)
    prevBtn.addEventListener("click", function () {
      prev();
      resetAuto();
    });

  dots.forEach(function (dot, i) {
    dot.addEventListener("click", function () {
      goTo(i);
      resetAuto();
    });
  });

  goTo(0);
  if (slides.length > 1) startAuto();

  // Pause on hover
  carousel.addEventListener("mouseenter", function () {
    clearInterval(timer);
  });
  carousel.addEventListener("mouseleave", startAuto);

  // Exposed so other components (e.g. the variant picker) can jump to a
  // specific slide, such as the image tied to a newly selected variant.
  carousel._cwCarouselGoTo = function (index) {
    goTo(index);
    resetAuto();
  };
});

/* ---- Cooper Bears Modals ---- */
(function () {
  var archives = document.querySelectorAll("[data-cw-bear-archive]");
  if (!archives.length) return;

  archives.forEach(function (archive) {
    var modalRoot = archive.querySelector("[data-cw-modal-root]");
    if (!modalRoot) return;

    // Move modals out of card/article stacking contexts so they always layer
    // above the page (fixed-position descendants can break when nested inside
    // transformed ancestors).
    modalRoot.querySelectorAll(".cw-modal[id]").forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });

    var filterToggleBtn = archive.querySelector("[data-cw-bear-filter-toggle]");
    var filterToggleLabel = archive.querySelector(
      "[data-cw-bear-filter-toggle-label]",
    );
    var filterPanel = archive.querySelector("[data-cw-bear-filter-panel]");
    var filterWrap = archive.querySelector("[data-cw-bear-filters]");
    var yearSelect =
      filterWrap && filterWrap.querySelector("[data-cw-bear-filter-year]");
    var tagSelect =
      filterWrap && filterWrap.querySelector("[data-cw-bear-filter-tag]");
    var resetBtn =
      filterWrap && filterWrap.querySelector("[data-cw-bear-filter-reset]");
    var cards = archive.querySelectorAll("[data-cw-bear-card]");
    var noResults = archive.querySelector("[data-cw-bear-no-results]");
    var groups = archive.querySelectorAll("[data-cw-bear-group]");

    var lastTrigger = null;

    function setFilterPanelOpen(isOpen) {
      if (!filterPanel || !filterToggleBtn) return;
      filterPanel.hidden = !isOpen;
      filterToggleBtn.setAttribute("aria-expanded", isOpen ? "true" : "false");
      if (filterToggleLabel) {
        filterToggleLabel.textContent = isOpen
          ? "Hide filters"
          : "Show filters";
      }
    }

    if (filterToggleBtn && filterPanel) {
      setFilterPanelOpen(false);
      filterToggleBtn.addEventListener("click", function () {
        setFilterPanelOpen(filterPanel.hidden);
      });
    }

    function hasTag(card, selectedTag) {
      if (!selectedTag) return true;
      var raw = (card.getAttribute("data-tags") || "").toLowerCase();
      var tags = raw
        .split(",")
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean);
      return tags.indexOf(selectedTag) >= 0;
    }

    function applyFilters() {
      var selectedYear = yearSelect ? (yearSelect.value || "").trim() : "";
      var selectedTag = tagSelect
        ? (tagSelect.value || "").trim().toLowerCase()
        : "";

      var visibleCount = 0;

      cards.forEach(function (card) {
        var yearValue = (card.getAttribute("data-year") || "").trim();
        var matchYear = !selectedYear || yearValue === selectedYear;
        var matchTag = hasTag(card, selectedTag);
        var show = matchYear && matchTag;

        var gridItem = card.closest(".cw-bear-filter-item");
        if (gridItem) {
          gridItem.hidden = !show;
        }

        if (show) visibleCount += 1;
      });

      groups.forEach(function (group) {
        var visibleInGroup = group.querySelectorAll(
          ".cw-bear-filter-item:not([hidden])",
        ).length;
        group.hidden = visibleInGroup === 0;
      });

      if (noResults) {
        noResults.hidden = visibleCount > 0;
      }
    }

    if (yearSelect) yearSelect.addEventListener("change", applyFilters);
    if (tagSelect) tagSelect.addEventListener("change", applyFilters);
    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        if (yearSelect) yearSelect.value = "";
        if (tagSelect) tagSelect.value = "";
        applyFilters();
      });
    }

    function setupGallery(gallery) {
      if (!gallery || gallery.dataset.cwGalleryReady === "true") return;

      var slides = Array.prototype.slice.call(
        gallery.querySelectorAll("[data-cw-gallery-slide]"),
      );
      var prevBtn = gallery.querySelector("[data-cw-gallery-prev]");
      var nextBtn = gallery.querySelector("[data-cw-gallery-next]");
      var count = gallery.querySelector("[data-cw-gallery-count]");

      if (!slides.length) return;

      var current = Math.max(
        0,
        slides.findIndex(function (slide) {
          return slide.classList.contains("is-active");
        }),
      );

      function ensureSlideLoaded(index) {
        var slide = slides[index];
        if (!slide) return;
        var img = slide.querySelector("img[data-src]");
        if (img) {
          img.setAttribute("src", img.getAttribute("data-src"));
          img.removeAttribute("data-src");
        }
      }

      function render() {
        ensureSlideLoaded(current);
        slides.forEach(function (slide, idx) {
          var active = idx === current;
          slide.classList.toggle("is-active", active);
          slide.hidden = !active;
        });
        if (count) {
          count.textContent = current + 1 + " / " + slides.length;
        }
      }

      function goTo(nextIndex) {
        current = (nextIndex + slides.length) % slides.length;
        render();
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          goTo(current - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          goTo(current + 1);
        });
      }

      gallery.dataset.cwGalleryReady = "true";
      gallery._cwGalleryGoTo = goTo;
      render();
    }

    function getOpenModal() {
      return document.querySelector(".cw-modal.is-open");
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("cw-modal-open");
      if (lastTrigger) {
        lastTrigger.focus();
      }
    }

    function openModal(modal, trigger) {
      if (!modal) return;

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      var existing = getOpenModal();
      if (existing) {
        closeModal(existing);
      }

      lastTrigger = trigger || null;
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("cw-modal-open");

      modal
        .querySelectorAll("[data-cw-modal-gallery]")
        .forEach(function (gallery) {
          setupGallery(gallery);
          if (typeof gallery._cwGalleryGoTo === "function") {
            gallery._cwGalleryGoTo(0);
          }
        });

      var closeBtn = modal.querySelector("[data-cw-modal-close]");
      if (closeBtn) closeBtn.focus();
    }

    modalRoot.querySelectorAll("[data-cw-modal-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-cw-modal-open");
        if (!id) return;
        var modal = document.getElementById(id);
        openModal(modal, btn);
      });
    });

    document.addEventListener("click", function (e) {
      var closeBtn = e.target.closest("[data-cw-modal-close]");
      if (closeBtn) {
        var modalFromBtn = closeBtn.closest(".cw-modal");
        closeModal(modalFromBtn);
        return;
      }

      var backdrop = e.target.closest(".cw-modal__backdrop");
      if (backdrop) {
        var modalFromBackdrop = backdrop.closest(".cw-modal");
        closeModal(modalFromBackdrop);
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var modal = getOpenModal();
      if (modal) closeModal(modal);
    });

    applyFilters();
  });
})();

/* ---- Cart Sidebar ---- */
(function () {
  const cartToggle = document.getElementById("cw-cart-toggle");
  const cartSidebar = document.getElementById("cw-cart-sidebar");
  const cartOverlay = document.getElementById("cw-cart-overlay");
  const cartClose = document.getElementById("cw-cart-close");

  if (!cartToggle || !cartSidebar || !cartOverlay || !cartClose) return;

  function openCart() {
    cartSidebar.classList.add("open");
    cartOverlay.classList.add("open");
    cartToggle.setAttribute("aria-expanded", "true");
    cartSidebar.removeAttribute("aria-hidden");
    document.body.style.overflow = "hidden";
  }

  function closeCart() {
    cartSidebar.classList.remove("open");
    cartOverlay.classList.remove("open");
    cartToggle.setAttribute("aria-expanded", "false");
    cartSidebar.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  cartToggle.addEventListener("click", function () {
    cartSidebar.classList.contains("open") ? closeCart() : openCart();
  });

  cartClose.addEventListener("click", closeCart);
  cartOverlay.addEventListener("click", closeCart);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && cartSidebar.classList.contains("open")) closeCart();
  });

  // Quantity button handlers
  document.addEventListener("click", function (e) {
    const qtyBtn = e.target.closest(".cw-qty-btn");
    if (!qtyBtn) return;

    const itemKey = qtyBtn.getAttribute("data-item-key");
    const action = qtyBtn.getAttribute("data-action");
    const form = qtyBtn.closest("form");
    
    if (!form || !itemKey) return;

    const inputName = `updates[${itemKey}]`;
    const input = form.elements[inputName];
    
    if (!input) return;

    const currentValue = parseInt(input.value) || 0;
    const newValue = action === "increase" ? currentValue + 1 : Math.max(0, currentValue - 1);
    
    input.value = newValue;
    form.submit();
  });
})();

/* ---- Product Variant Picker ---- */
(function () {
  var root = document.querySelector("[data-cw-variant-picker]");
  if (!root) return;

  var dataScript = root.querySelector("[data-cw-variant-data]");
  var variants = [];
  try {
    variants = JSON.parse((dataScript && dataScript.textContent) || "[]");
  } catch (e) {
    return;
  }
  if (!variants.length) return;

  var idInput = document.querySelector("[data-cw-variant-id]");
  var priceDisplay = document.querySelector("[data-cw-price-display]");
  var addBtn = document.querySelector("[data-cw-add-to-cart]");
  var addLabel = addBtn && addBtn.querySelector("[data-cw-add-label]");
  var addIcon = addBtn && addBtn.querySelector("[data-cw-add-icon]");
  var optionGroups = Array.prototype.slice.call(
    root.querySelectorAll(".cw-variant-option"),
  );

  // Seed the current selection from whichever pills render as selected.
  var selected = {};
  root
    .querySelectorAll("[data-cw-option-btn].is-selected")
    .forEach(function (btn) {
      selected[btn.getAttribute("data-option-position")] =
        btn.getAttribute("data-option-value");
    });

  function matches(variant, selection) {
    return ["1", "2", "3"].every(function (position) {
      var value = selection[position];
      return value === undefined || variant["option" + position] === value;
    });
  }

  function findVariant(selection) {
    return variants.filter(function (variant) {
      return matches(variant, selection);
    })[0];
  }

  function isReachable(position, value) {
    var trial = Object.assign({}, selected);
    trial[position] = value;
    return variants.some(function (variant) {
      return variant.available && matches(variant, trial);
    });
  }

  function updatePriceDisplay(variant) {
    if (!priceDisplay) return;
    var saleRow = priceDisplay.querySelector("[data-cw-price-sale-row]");
    var plain = priceDisplay.querySelector("[data-cw-price-plain]");
    var save = priceDisplay.querySelector("[data-cw-price-save]");
    var mainEl = priceDisplay.querySelector("[data-cw-price-main]");
    var wasEl = priceDisplay.querySelector("[data-cw-price-was]");
    var pctEl = priceDisplay.querySelector("[data-cw-price-pct]");

    if (variant.onSale) {
      if (mainEl) mainEl.textContent = variant.priceHtml;
      if (wasEl) wasEl.textContent = variant.compareHtml;
      if (pctEl) pctEl.textContent = variant.pct + "% OFF";
      if (save) {
        save.textContent = "You save " + variant.saveHtml;
        save.hidden = false;
      }
      if (saleRow) saleRow.hidden = false;
      if (plain) plain.hidden = true;
    } else {
      if (plain) {
        plain.textContent = variant.priceHtml;
        plain.hidden = false;
      }
      if (saleRow) saleRow.hidden = true;
      if (save) save.hidden = true;
    }
  }

  function updateAddToCart(variant) {
    if (!addBtn) return;
    var available = !!(variant && variant.available);
    addBtn.disabled = !available;
    addBtn.classList.toggle("cw-btn-primary", available);
    addBtn.classList.toggle("cw-btn-outline", !available);
    if (addLabel) {
      addLabel.textContent = available
        ? addBtn.getAttribute("data-add-label")
        : addBtn.getAttribute("data-sold-out-label");
    }
    if (addIcon) {
      addIcon.textContent = available
        ? "add_shopping_cart"
        : "remove_shopping_cart";
    }
  }

  function updateGallery(variant) {
    if (!variant || !variant.featuredImageId) return;
    var slide = document.querySelector(
      '.cw-carousel-slide[data-image-id="' + variant.featuredImageId + '"]',
    );
    var carousel = slide && slide.closest(".cw-carousel");
    if (!carousel || typeof carousel._cwCarouselGoTo !== "function") return;
    var index = Array.prototype.indexOf.call(
      carousel.querySelectorAll(".cw-carousel-slide"),
      slide,
    );
    if (index >= 0) carousel._cwCarouselGoTo(index);
  }

  function render() {
    optionGroups.forEach(function (group) {
      var buttons = group.querySelectorAll("[data-cw-option-btn]");
      var label = group.querySelector("[data-cw-option-value-label]");
      var position = buttons[0] && buttons[0].getAttribute("data-option-position");

      buttons.forEach(function (btn) {
        var value = btn.getAttribute("data-option-value");
        var isActive = selected[position] === value;
        btn.classList.toggle("is-selected", isActive);
        btn.setAttribute("aria-checked", isActive ? "true" : "false");
        btn.classList.toggle("is-unavailable", !isReachable(position, value));
      });

      if (label) label.textContent = selected[position] || "";
    });

    var variant = findVariant(selected);
    if (variant) {
      if (idInput) idInput.value = variant.id;
      updatePriceDisplay(variant);
      updateGallery(variant);
    }
    updateAddToCart(variant);
  }

  root.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-cw-option-btn]");
    if (!btn) return;
    selected[btn.getAttribute("data-option-position")] =
      btn.getAttribute("data-option-value");
    render();
  });

  render();
})();

/* ---- Number Ticker (counts up to a target once scrolled into view) ---- */
(function () {
  const counters = document.querySelectorAll("[data-cw-counter]");
  if (!counters.length) return;

  function animateCounter(el) {
    const target = parseInt(el.getAttribute("data-cw-counter"), 10);
    if (isNaN(target)) return;
    const duration = 1200;
    const start = performance.now();

    function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      el.textContent = Math.round(progress * target);
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  if (!("IntersectionObserver" in window)) {
    counters.forEach(animateCounter);
    return;
  }

  const observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  counters.forEach(function (el) {
    observer.observe(el);
  });
})();
